export const PAGE_SIZE = 12;
export const PAGE_PARAM = 'page';
export const MY_TEAM_OVERVIEW_PAGE_SIZE = 5;